module.exports = __webpack_public_path__ + "static/img/3.23391b3a.png";